<template>
  <div
    class="cards-sidebar-item"
    :style="hoverStyle"
    :class="isActive"
    @click="$emit('clickSidebarItem', index)"
  >
    <span class="cards-sidebar-item__count">{{ count }}</span>
    <span class="cards-sidebar-item__text">{{ title }}</span>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'CardsSidebarItem',

    inject: {
      rubricColor: {
        default() {
          return () => '#EBEBEB';
        },
      },

      activeCardIndex: {
        default() {
          return () => -1;
        },
      },

      isPartner: {
        default() {
          return () => false;
        },
      },
    },

    props: {
      index: {
        required: true,
        type: Number as PropType<number>,
      },

      title: {
        type: String as PropType<string>,
        default: '',
      },
    },

    emits: ['clickSidebarItem'],

    computed: {
      hoverStyle(): Record<string, string> {
        // @ts-expect-error injected functions are not typed in options API
        const isPartner = this.isPartner();
        if (isPartner) {
          return { '--active-color': '#EBEBEB' };
        }
        return {
          // @ts-expect-error injected functions are not typed in options API
          '--active-color': this.rubricColor(),
        };
      },

      count(): number {
        return Number(this.index) + 1;
      },

      isActive() {
        // @ts-expect-error injected functions are not typed in options API
        const activeCardIndex = this.activeCardIndex();
        return {
          'cards-sidebar-item__active': activeCardIndex === this.index,
        };
      },
    },
  });
</script>

<style lang="scss" scoped>
  .cards-sidebar-item {
    padding: $spacing-4 $spacing-6;
    color: $mainBlack;
    border: 2px solid #e7e7e7;
    border-radius: 32px;
    display: flex;
    position: relative;
    width: calc(100% - 4px);
    @include hover {
      border: 2px solid transparent;
      &::before {
        position: absolute;
        content: '';
        top: 0px;
        left: -2px;
        height: 100%;
        width: calc(100% + 4px);
        border-radius: 32px;
        border: 4px solid var(--active-color);
        cursor: pointer;
      }
    }
    &__count {
      margin-top: 2px;
      font-family: $headline-font--1;
      font-size: 18px;
      line-height: 24px;
    }
    &__text {
      word-break: break-word;
      font-family: $text-font--1;
      margin-left: $spacing-4;
      font-size: 18px;
      line-height: 28px;
    }
    &__active {
      background-color: var(--active-color);
      border: 2px solid transparent;
      @include hover {
        &::before {
          left: 0;
          width: 100%;
          border: 0;
        }
      }
    }
  }
</style>
